module.exports = __webpack_public_path__ + "img/airbnb_logo.8c940ce7.png";